import createIcon from '../../createIcon';

/**
 * @component @name SpeakerNotesOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi4yNyAxTDEgMi4yN0wzLjAxIDQuMjhMMyAyMS4yN0w3IDE3LjI3SDE2TDIxLjczIDIzTDIzIDIxLjczTDIuMjcgMVpNOSAxMy4yN0g3VjExLjI3SDlWMTMuMjdaTTcgMTAuMjdWOC4yN0w5IDEwLjI3SDdaTTIxIDEuMjdINS4wOEwxMSA3LjE5VjUuMjdIMTlWNy4yN0gxMS4wOEwxMi4wOCA4LjI3SDE5VjEwLjI3SDE0LjA4TDIxLjA3IDE3LjI2QzIyLjE0IDE3LjIyIDIzIDE2LjM1IDIzIDE1LjI3VjMuMjdDMjMgMi4xNyAyMi4xIDEuMjcgMjEgMS4yN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SpeakerNotesOff = createIcon('SpeakerNotesOff', [
  [
    'path',
    {
      d: 'M2.27 1L1 2.27L3.01 4.28L3 21.27L7 17.27H16L21.73 23L23 21.73L2.27 1ZM9 13.27H7V11.27H9V13.27ZM7 10.27V8.27L9 10.27H7ZM21 1.27H5.08L11 7.19V5.27H19V7.27H11.08L12.08 8.27H19V10.27H14.08L21.07 17.26C22.14 17.22 23 16.35 23 15.27V3.27C23 2.17 22.1 1.27 21 1.27Z',
      key: 'p5j3lk',
    },
  ],
]);

export default SpeakerNotesOff;
